import React from 'react'

const FAQ = () => {
  return (
    <>
      <div className='p-8 m-8 bangla-font'>
        <h2 className='text-3xl font-extrabold leading-9 border-b-2 border-gray-100 text-gray-900 mb-12'>
          FAQs
        </h2>
        <ul className='flex items-start gap-8 flex-wrap'>
          <li className='w-2/5'>
            <p className='text-lg font-bold leading-6 text-gray-900'>
              জরুরী পরিস্থিতিতে আমি আমার পোষা প্রাণীকে কোথায় নিয়ে যাব?
            </p>

            <p className='text-base leading-6 text-gray-500 mt-2 '>
              ব্যস্ত সময়ের মধ্যে যদি কোনো জরুরী অবস্থা দেখা দেয়, তবে আমাদের
              অফিসে সময়ের আগে কল করুন যাতে আমরা জানি যে কী করতে হবে এবং আপনার
              পোষা প্রাণীকে কোথায় নিয়ে যেতে হবে। জরুরি অবস্থায়, আমাদের উত্তর
              পরিষেবা আপনাকে আমাদের দলের একজন সদস্যের সাথে সংযুক্ত করতে পারে,
              প্রয়োজনে যিনি আপনাকে নিকটস্থ জরুরি ক্লিনিকে নির্দেশ দেবেন।
            </p>
          </li>
          <li className='w-2/5'>
            <p className='text-lg font-bold leading-6 text-gray-900'>
              আমি একটি স্ট্রে প্রাণী খুঁজে পেয়েছি. আমার কি করা উচিৎ?
            </p>

            <p className='text-base leading-6 text-gray-500 mt-2 '>
              পশুর কলার/ট্যাগ চেক করুন। যদি কেউ উপস্থিত না থাকে তবে নির্দ্বিধায়
              ভিতরে আসুন এবং একটি মাইক্রোচিপ পরীক্ষা করার জন্য পোষা প্রাণীটিকে
              স্ক্যান করুন৷ যদি কোনও মাইক্রোচিপ উপস্থিত না থাকে তবে আপনি এলাকায়
              "হারানো প্রাণী" চিহ্নগুলি সন্ধান করার সময় পোষা প্রাণীটিকে নিরাপদ
              রাখুন৷ এছাড়াও আপনি কাছাকাছি পশু উদ্ধার দল কল করতে পারেন.
            </p>
          </li>
          <li className='w-2/5'>
            <p className='text-lg font-bold leading-6 text-gray-900'>
              আমার পোষা প্রাণীর কি ফুড এলার্জি আছে?
            </p>

            <p className='text-base leading-6 text-gray-500 mt-2 '>
              যদি কোনও পোষা প্রাণী স্বাভাবিকের চেয়ে বেশি চুলকায় বা তাদের পায়ে
              চিবিয়ে থাকে, তাদের আন্ডারআর্ম বা মুখ আঁচড়ায় বা মনে হয় যে এতে
              হট স্পট রয়েছে, লোকেরা প্রায়শই খাবারের অ্যালার্জির জন্য দায়ী বলে
              মনে করে। যদিও খাদ্য একটি পোষা প্রাণীর ত্বকের সমস্যার একটি উপাদান
              হতে পারে, একটি প্রকৃত খাদ্য অ্যালার্জি অসম্ভাব্য। "প্রায় 10% পোষা
              প্রাণীর আসল খাবারের অ্যালার্জি আছে," নেলসন বলেছিলেন। "অন্য 90%
              চুলকানি, অস্বস্তিকর পোষা প্রাণীরা সাধারণত আমাদের মতো শ্বাস নেওয়া
              অ্যালার্জেন বা ফ্লি অ্যালার্জি হয়।
            </p>
          </li>
          <li className='w-2/5'>
            <p className='text-lg font-bold leading-6 text-gray-900'>
              আমার কুকুর/বিড়াল অথবা পোষা প্রাণী কে বার্ষিক পরীক্ষার জন্য নিয়ে
              আসা কি প্রয়োজনীয়?
            </p>

            <p className='text-base leading-6 text-gray-500 mt-2 '>
              বছরে অন্তত একবার ব্যাপক পরীক্ষা করার পরামর্শ দেওয়া হয়। আপনার
              পোষা প্রাণীর সুস্থতা পরীক্ষার সময়, আপনার পশুচিকিত্সক আপনার পোষা
              প্রাণীর ইতিহাস নেবেন এবং একটি পুঙ্খানুপুঙ্খ শারীরিক পরীক্ষা করবেন।
              তিনি আপনার পোষা প্রাণীকে উপযুক্ত টিকা দেবেন, একটি ডায়াগনস্টিক
              ওয়ার্কআপ করবেন এবং দাঁতের কাজ বা অন্যান্য ফলো-আপ যত্নের সুপারিশ
              করতে পারেন। আপনি আপনার পোষা প্রাণী বা তাদের আচরণে কোনো শারীরিক
              পরিবর্তন লক্ষ্য করেছেন কিনা তা আপনার পশুচিকিত্সককে জানান।
            </p>
          </li>
        </ul>
      </div>
    </>
  )
}

export default FAQ
